/*
 * Copyright 2025 iodyne.  All rights reserved.
 * Use is subject to license terms.
 */

// Types
export enum StabilityClass {
  nightly = "nightly",
  weekly = "weekly",
  release = "release"
}

export enum FirmwareTags {
  official = "official",
  preofficial = "preofficial",
  alpha = "alpha",
  beta = "beta"
}

export enum ImageBuildAttrs {
  R = "R",
  D = "D",
  K = "K",
  X = "X"
}



export interface FirmwareImageBaseMetadata {
  image_name:string,
  image_version:string,
  image_build_attrs:Array<ImageBuildAttrs>,
}

export interface FirmwareImageMetadata extends FirmwareImageBaseMetadata {
  signature:string,
  image_filename:string,
  stability_class:StabilityClass,
  tags:Array<FirmwareTags>,
  available:boolean,
  notify: boolean,
  min_client_feature_level: number,
  extra_metadata:Map<string, string>
}

export interface FirmwareImageURL {
  image_id: string,
  image_url: string
}

// Helpers
export function uniqueIDForFW(metadata:FirmwareImageBaseMetadata):string {
    var id_base = `${metadata.image_name}-${metadata.image_version}+`;
    return id_base + metadata.image_build_attrs.map((attr) => attr.valueOf).concat();
}